import { AccountModalNames, useAccountModals } from '@/components/Modals/Account';
import { cn } from '@/lib/utils';
import { Button } from '@music-vine/cadence/ui';
import type { ReactNode } from 'react';
import { commonClassNamePartials } from '../utils/common-styles';
interface BoardsAuthRequired {
  message?: ReactNode;
}
export const BoardsAuthRequired = ({
  message
}: BoardsAuthRequired) => {
  const {
    setCurrentModal
  } = useAccountModals();
  return <div className={cn('flex flex-1 flex-col items-center justify-center gap-4 px-4', commonClassNamePartials())} data-sentry-component="BoardsAuthRequired" data-sentry-source-file="AuthRequired.tsx">
      <div className="flex flex-col gap-4 text-center">
        {message ? message : <div className="font-heading font-normal text-base text-black tracking-tight dark:text-white">
            <span>Please</span>
            <Button className="w-min px-2 font-heading text-base text-pink-600 underline enabled:hover:bg-transparent" noFeedback onClick={() => setCurrentModal(AccountModalNames.Login)} size="lg" variant="transparent">
              log in
            </Button>
            <span>to view this page</span>
          </div>}
      </div>
    </div>;
};